import React from "react";

import { useIntl } from "react-intl";

import CustomField from "@mapmycustomers/shared/types/customField/CustomField";

import {
  getCustomFieldDataTypeDescription,
  getCustomFieldDataTypePreviewImage,
} from "@app/util/ui";

import styles from "./CustomFieldPreview.module.scss";

interface Props {
  dataType: CustomField["dataType"];
}

const CustomFieldPreview: React.FC<Props> = ({ dataType }) => {
  const intl = useIntl();

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        {intl.formatMessage({
          id: "settings.customFields.createEditPane.customFieldPreview.title",
          defaultMessage: "What will this field look like?",
          description: "Settings Custom field - create/edit - title of preview",
        })}

        <div className={styles.description}>
          {getCustomFieldDataTypeDescription(intl, dataType)}
        </div>
      </div>
      <div className={styles.imageContainer}>
        <img
          alt={dataType}
          className={styles.image}
          src={getCustomFieldDataTypePreviewImage(dataType)}
        />
      </div>
    </div>
  );
};

export default CustomFieldPreview;
